import { createFileRoute } from '@tanstack/react-router';
import { AdminAddonsPage } from '../../features/billing';

export const Route = createFileRoute('/admin/addons')({ component: AdminAddonsPage });
